import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const SIGNUPS_LIST_KEY = "signupsList";

export const signupsListKeys = createKeys(
  featureKeys.SIGNUPS_LIST_FEATURE_KEY,
  {
    signupsList: () => [SIGNUPS_LIST_KEY],
  }
);
